import type {AcapulcoProperty} from "@casas-diamante/types"

type SeaviewInput = AcapulcoProperty["seaview"] | undefined
type SeaviewOption = Exclude<AcapulcoProperty["seaview"], boolean> | null

const normalizeSeaviewValue = (value: SeaviewInput): SeaviewOption => {
   if (value === true || value === "yes") return "yes"
   if (value === false || value === "no") return "no"
   if (value === "partial") return "partial"
   return null
}

const prepareSeaviewForStorage = (value: SeaviewInput) => {
   if (value === true || value === "yes") return true
   if (value === false || value === "no") return false
   if (value === "partial") return "partial"
   return null
}

const getSeaviewLabel = (value: SeaviewInput) => {
   const normalized = normalizeSeaviewValue(value)
   if (normalized === "yes") return "Con vista al mar"
   if (normalized === "no") return "Sin vista al mar"
   if (normalized === "partial") return "Vista parcial al mar"
   return "Sin dato de vista al mar"
}

export type {SeaviewInput, SeaviewOption}
export {normalizeSeaviewValue, prepareSeaviewForStorage, getSeaviewLabel}
